import useRTData from './hooks/useRTData';
import useChatRoom from './hooks/useChatRoom';

// This component ensures that all Outlets
// have access to RT data and the emitter fns.
export default function RealTimeDataProvider({ render }) {
  const dashboardFeatures = useRTData();
  const chatRoomFeatures = useChatRoom();
  return render({ dashboardFeatures, chatRoomFeatures });
}
